import { render, staticRenderFns } from "./QuestionnaireList.vue?vue&type=template&id=8b1e38d4&scoped=true"
import script from "./QuestionnaireList.vue?vue&type=script&lang=js"
export * from "./QuestionnaireList.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireList.vue?vue&type=style&index=0&id=8b1e38d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1e38d4",
  null
  
)

export default component.exports